import React from 'react';

const VotingPeriod = () => (
  <div>
    <p>VotingPeriod here</p>
  </div>
);

export default VotingPeriod;
